import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../../utils/AppUtils";

const BackButton = () => {
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);

  return (
    
      <div className="col-md-12 mb-4 d-flex justify-content-start">
        <button
          className="btn btn-primary-complete bckbtn"
          onClick={() => {
            clickStreamUser("back-btn", {
              userId: authBroker?.payload?.user.user_id,
            });
            navigate(-1)
          }}
        >
          Back
        </button>
        
      </div>
    
  );
};

export default BackButton;
